module.exports = __webpack_public_path__ + "fonts/inter-latin-700-normal.woff2";